import React from "react"

export default React.createContext({
  lang: "da",
  setLang: () => {},
})
